import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between bg-[#0A1128] text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 grid-glow opacity-40" />
        <div className="relative"><Logo dark size="lg" /></div>
        <div className="relative">
          <h2 className="font-head text-4xl font-extrabold tracking-tight leading-tight">Mission Control for a Global Workforce.</h2>
          <p className="mt-4 text-slate-300 text-lg max-w-md">One Global Workforce. One Operating System. Track tasks, field work, leads and sales across every city and time zone.</p>
        </div>
        <div className="relative text-sm text-slate-500">© {new Date().getFullYear()} GTForce — Global Task Force</div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo size="lg" /></div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight text-[#0A1128]">{title}</h1>
          {subtitle && <p className="mt-2 text-slate-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-600">{footer}</div>}
          <div className="mt-8 text-center">
            <Link to="/" className="text-sm text-slate-400 hover:text-[#1D4ED8]">← Back to home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, ...props }) {
  return (
    <div>
      <label className="text-sm font-medium text-slate-700">{label}</label>
      <input {...props} className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:border-[#1D4ED8] focus:ring-1 focus:ring-[#1D4ED8] outline-none transition-colors" />
    </div>
  );
}
